<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.dt_ultima_ficha="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data da última atualização do Cadastro Individual (CI) do cidadão"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.dt_ultima_ficha="{ item }">
            {{ formatDate(item.dt_ultima_ficha) }} <br />
            ({{ item.percent_fci_completa }}%)
          </template>

          <template v-slot:item.dt_ultimo_acompanhamento="{ item }">
            <div v-if="item.dt_ultimo_acompanhamento == null">
              Sem atendimento
            </div>
            <div v-else class="ultimo-acompanhamento">
              {{ formatDate(item.dt_ultimo_acompanhamento) }}
              <span>
                {{ item.tp_ultimo_acompanhamento }}
              </span>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>CI</th>
                    <th>CDT</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <th>Vulnerabilidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>
                      {{ formatDate(item.dt_ultima_ficha) }} <br />
                      ({{ item.percent_fci_completa }}%)
                    </td>
                    <td>
                      {{ formatDate(item.dt_ultima_fcd) }} <br />
                      ({{ item.percent_fcdt_completa }}%)
                    </td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td>
                      {{ item.vulnerabilidade.replace(/^\[|\]$/g, '') }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>Medicina</th>
                    <th>Enfermagem</th>
                    <th>Odonto</th>
                    <th>eMulti</th>
                    <th>Vacina</th>
                    <th>Procedimento</th>
                    <th>Coletivo</th>
                    <th>Alimentar</th>
                    <th>Visita</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        v-if="item.dt_ult_fai_med !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fais_med_enf,
                            'Medicina, Atendimentos individuais',
                            'Medicina'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fai_med) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_medico }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fai_enf !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fais_med_enf,
                            'Enfermagem, Atendimentos individuais',
                            'Enfermagem'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fai_enf) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_enfermeiro }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fao !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.faos,
                            'Odontologia, Atendimentos individuais',
                            'Odonto'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fao) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_odonto }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fai_emulti !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fais_emulti,
                            'Profissionais eMulti, Atendimentos individuais',
                            'eMulti'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fai_emulti) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_emulti }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_vacina !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(item, item.vacinas, 'Vacinas', 'Vacina')
                        "
                      >
                        {{ formatDate(item.dt_ult_vacina) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_vacina }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fp !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fps,
                            'Procedimentos',
                            'Procedimento'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fp) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_proced }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fac !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.facs,
                            'Atividade Coletiva',
                            'Coletivo'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fac) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_atvd_coletiva }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fmca !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fmca,
                            'Marcadores de Consumo Alimentar',
                            'Alimentar'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fmca) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_cons_alimnt }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.dt_ult_fvdt !== null"
                        class="table-interna-acompanhamento-item"
                        @click="
                          openModal(
                            item,
                            item.fvdts,
                            'Visita Domiciliar',
                            'Visita'
                          )
                        "
                      >
                        {{ formatDate(item.dt_ult_fvdt) }}
                        <br />
                        <div>
                          {{ item.qtd_atendimentos.qtd_visitas }}
                          registro(s)
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="
                  (item.is_acompanhado == 0 || item.is_acompanhado == null) &&
                  Number(item.qtd_atendimentos?.qt_atends ?? 0) < 1
                "
                variant="danger"
                show
                >Precisa ter pelo menos 1 atendimento individual ou 1 atividade
                coletiva de: Medicina ou Enfermagem ou Odontologia ou
                eMulti.</b-alert
              >

              <b-alert
                v-if="
                  (item.is_acompanhado == 0 || item.is_acompanhado == null) &&
                  Number(item.qtd_atendimentos?.qt_atends ?? 0) < 2 &&
                  Number(item.qtd_atendimentos?.qtd_proced ?? 0) < 1
                "
                variant="danger"
                show
                >Precisa ter pelo menos 2 registros somando os atendimentos e
                procedimentos de Medicina, Enfermagem, Odontologia, eMulti ou
                Visitas domiciliares.
              </b-alert>

              <b-alert
                v-if="
                  (item.is_acompanhado == 0 || item.is_acompanhado == null) &&
                  (item.dias_fci_atualizada == null ||
                    item.dias_fci_atualizada > 730)
                "
                variant="danger"
                show
                >Precisa atualizar o cadastro individual. Lembrando de preencher
                todos os campos da ficha ao atualizar ela.</b-alert
              >
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-acompanhamento"
        ref="modal"
        title=""
        v-model="modal.show"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> {{ modal.title }}</template>
        <div class="modal-acompanhamento-body" v-if="modal.item != null">
          <table class="table table-interna">
            <thead>
              <tr>
                <th
                  v-for="(itemHeader, indexHeader) in modal.headers"
                  :key="indexHeader"
                >
                  {{ itemHeader.label }}
                  <span
                    v-if="itemHeader.icon.show == true"
                    v-b-tooltip.hover.top
                    :title="itemHeader.icon.text"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody v-if="modal.tipo != 'Visita'">
              <tr v-for="(item2, index2) in modal.items" :key="index2">
                <td>{{ index2 + 1 }}</td>
                <td>
                  {{
                    item2.dt_atendimento != null
                      ? formatDate(item2.dt_atendimento)
                      : ''
                  }}
                </td>
                <td>
                  {{ item2.equipe }}
                  <span
                    v-if="item2.equipe"
                    v-b-tooltip.hover
                    v-bind:title="item2.no_equipe"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item2.nu_cbo }}
                  <span
                    v-if="item2.nu_cbo"
                    v-b-tooltip.hover
                    v-bind:title="item2.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>{{ item2.ficha }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item2, index2) in modal.items" :key="index2">
                <td>{{ index2 + 1 }}</td>
                <td>
                  {{
                    item2.dt_atendimento != null
                      ? formatDate(item2.dt_atendimento)
                      : ''
                  }}
                </td>
                <td>
                  {{ item2.motivo_acomp.join(', ') }}
                </td>
                <td>
                  {{ item2.equipe }}
                  <span
                    v-if="item2.equipe"
                    v-b-tooltip.hover
                    v-bind:title="item2.no_equipe"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item2.nu_cbo }}
                  <span
                    v-if="item2.nu_cbo"
                    v-b-tooltip.hover
                    v-bind:title="item2.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>{{ item2.ficha }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from './copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'CI',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_ficha',
          width: '200px',
        },
        {
          text: 'Acompanhamento',
          align: 'start',
          filterable: false,
          value: 'dt_ultimo_acompanhamento',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modal: {
        title: '',
        show: false,
        item: null,
        headers: [],
        items: [],
        tipo: '',
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          let qtd_atendimentos

          try {
            qtd_atendimentos =
              item.qtd_atendimentos != null
                ? JSON.parse(item.qtd_atendimentos)
                : null
          } catch (e) {
            console.error("Erro ao fazer parse de 'qtd_atendimentos':", e)
            qtd_atendimentos = null
          }

          return {
            id: index,
            ...item,
            qtd_atendimentos: qtd_atendimentos,
          }
        })
      }
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    getPagination(options) {
      this.currentPage = options.page
    },

    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    openModal(item, dados, title, tipo) {
      this.modal.show = true
      this.modal.item = item
      this.modal.title = title
      this.modal.tipo = tipo
      try {
        // headers
        switch (tipo) {
          case 'Visita':
            this.modal.headers = [
              {
                label: 'Nº',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Atendimento',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Motivo',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Equipe',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'CBO',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Ficha',
                icon: {
                  show: false,
                  text: '',
                },
              },
            ]
            break
          default:
            this.modal.headers = [
              {
                label: 'Nº',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Atendimento',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Equipe',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'CBO',
                icon: {
                  show: false,
                  text: '',
                },
              },
              {
                label: 'Ficha',
                icon: {
                  show: false,
                  text: '',
                },
              },
            ]
            break
        }

        // items
        let items = dados != null ? JSON.parse(dados) : []

        if (tipo == 'Medicina') {
          items = items.filter((el) => {
            return el.nu_cbo && !el.nu_cbo.startsWith('2235')
          })
          this.modal.items = items
          return
        }

        if (tipo == 'Enfermagem') {
          items = items.filter((el) => {
            return el.nu_cbo && el.nu_cbo.startsWith('2235')
          })
          this.modal.items = items
          return
        }

        this.modal.items = items
      } catch (e) {
        console.error('Erro ao fazer parse', e)
      }
    },

    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.table-interna-acompanhamento-item {
  cursor: pointer;
  background-color: green;
  // min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px;
  border: 1px solid #ccc;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
}
</style>
